
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 0L0 7.333l5.455 2.665v7.333L15 22l9.546-4.669V9.998l2.727-1.332v8.445H30V7.333L15 0zm9.3 7.333L15 11.88 5.7 7.333 15 2.787l9.3 4.546zm-2.482 8.544L15 19.213l-6.818-3.336V11.33L15 14.667l6.818-3.337v4.547z","fill":"#282828"}})])
          )
        }
      }
    